import type { PhoneCallView } from '../../phone-calls/types';
import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../configurations';
import AniAliIconInactive from '../images/phone-icons/unselected/ani_ali_unselected.svg';
import AniAliIconSelected from '../images/phone-icons/selected/ani_ali_selected.svg';
import { isValidLatLng } from '../../location/helpers';
import type { LabelClassProperties, PhoneCallGeoPointEntity } from '../types';
import { colors } from '../../colors/colors';

export const convertPhoneCallToGeoPointEntity = (
    phoneCall: PhoneCallView
): PhoneCallGeoPointEntity | undefined => {
    if (
        phoneCall &&
        isValidLatLng(
            phoneCall.normalizedPhoneCallDisplay?.latFloat,
            phoneCall.normalizedPhoneCallDisplay?.lngFloat
        )
    ) {
        return {
            entityId: phoneCall.id,
            latitude: phoneCall.normalizedPhoneCallDisplay.latFloat!,
            longitude: phoneCall.normalizedPhoneCallDisplay.lngFloat!,
        };
    }
    return undefined;
};

export const phoneCallUniqueValueInfos = [
    {
        value: 'e911_inactive',
        symbol: {
            type: 'picture-marker',
            url: AniAliIconInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'e911_selected',
        symbol: {
            type: 'picture-marker',
            url: AniAliIconSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const phoneCallIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    uniqueValueInfos: phoneCallUniqueValueInfos,
    authoringInfo: undefined,
    defaultSymbol: {
        type: 'picture-marker',
        url: AniAliIconInactive,
        width: '32px',
        height: '32px',
    },
};

export const phoneCallIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelText,
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
        xoffset: 0,
        yoffset: 5,
        haloSize: '1px',
        haloColor: colors.mapLabelHalo,
    },
    labelPlacement: 'below-center',
    labelExpressionInfo: {
        expression: "'E911'",
    },
    maxScale: 0,
    minScale: 25000000,
};
